import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchHistory } from "./api";
import type { HistoryEntry } from "./api";

// Общая история override'ов роли — промпт и модель в одном ответе (см.
// fetchHistory). Потребители (`OverrideHistory`, используется и из
// RoleEditor, и из RoleModelEditor) фильтруют по `kind` и показывают до
// 10 своих записей, свежие первыми — порядок задаёт backend. Общий ключ
// кэша на обе секции — запрос один. `enabled` зависит от выбранной роли.
export function useRoleHistory(
  roleName: string | null,
): UseQueryResult<readonly HistoryEntry[], Error> {
  return useOrgScopedQuery<readonly HistoryEntry[]>({
    key: ["agent-roles", "history", roleName],
    queryFn: () => fetchHistory(roleName ?? ""),
    enabled: roleName !== null,
    retry: false,
  });
}
